/** * Created by vouill on 11/13/17. */

<template>
  <div>
    <div class="headline">
      <h1>Ваш профиль</h1>
    </div>
    <p v-if="profile.name"><strong>Имя:</strong> {{ profile.name }}</p>
    <p v-if="profile.phone"><strong>Телефон:</strong> {{ profile.phone }}</p>
    <p v-if="profile.email"><strong>Email:</strong> {{ profile.email }}</p>
    <p v-if="accessUI"><strong>Доступы:</strong> {{ accessUI }}</p>
  </div>
</template>

<style lang="scss" scoped>
.headline {
  margin-top: 1em;
  display: flex;
  img {
    height: 80px;
    width: 80px;
    border-radius: 50%;
  }
}
</style>

<script>
import { mapState } from "vuex";

export default {
  name: "account",
  computed: mapState({
    profile: state => state.user.profile,
    accessUI: state => state.user.profileAccess
  })
};
</script>
